import { render } from "./Showtm.vue?vue&type=template&id=6454e482&scoped=true"
import script from "./Showtm.vue?vue&type=script&lang=js"
export * from "./Showtm.vue?vue&type=script&lang=js"

import "./Showtm.vue?vue&type=style&index=0&id=6454e482&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6454e482"]])

export default __exports__